<template>
  <el-container class="main-layout-container">
    <el-header class="main-header">
      <div class="logo">拓疆设备绑定后台管理系统</div>
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-user" v-show="accounttype==='1'">{{this.notice}}</el-dropdown-item>
          <el-dropdown-item icon="el-icon-setting" @click.native="configpass">个人设置</el-dropdown-item>
          <el-dropdown-item  @click.native="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-header>

    <el-container>
      <el-aside width="220px" class="main-aside">
        <el-menu
          :default-active="this.$route.path"
          router
          class="el-menu-vertical-demo"
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
        >
          <el-menu-item index="/device/bind" @click="goto('/device/bind')">
            <i class="el-icon-link"></i>
            <span slot="title">设备 SN 绑定</span>
          </el-menu-item>

          <el-menu-item index="/device/list" @click="goto('/device/list')" >
            <i class="el-icon-tickets"></i>
            <span slot="title">设备信息查看</span>
          </el-menu-item>

          <el-menu-item index="/device/member" @click="goto('/device/member')" v-show="accounttype==='1'">
            <i class="el-icon-user"></i>
            <span slot="title">水枪会员服务</span>
          </el-menu-item>

          <el-menu-item index="/device/download" @click="goto('/device/download')">
            <i class="el-icon-mobile-phone"></i>
            <span slot="title">APP 下载</span>
          </el-menu-item>

        </el-menu>
      </el-aside>

      <el-main class="main-content">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import axios from '../../utils/request'
import router from '../../router/index'

export default {
  name: 'MainLayout',
  data () {
    return {
      username: '',
      accounttype: 2,
      notice: '请购买会员'
    }
  },
  mounted () {
    axios.get('/order/get/show').then((res) => {
      if (res.code === 200 || res.status === 200) {
        this.accounttype = res.data.accounttype
      }
    })
    this.username = localStorage.getItem('username')

    axios.post('/order/pay/getMember', {}, { noLoading: true }).then(res => {
      console.log('接口返回:', res.data)
      var patterndate = res.data.expire_time.split('T')[0]
      if (res.code === 200) {
        if (this.isPast(res.data.expire_time)) {
          this.notice = '会员已过期'
        } else {
          this.notice = '会员有效期到' + patterndate
        }
      }
    })

    router.push(router.path).go(0)
  },
  methods: {
    logout () {
      axios.get('/data/logout').then((res) => { // <-- 使用箭头函数
        // 确保后端返回成功状态码，通常是 200 或其他逻辑判断
        if (res.code === 200 || res.status === 200) {
          // 成功调用后端登出接口后，执行本地清除和跳转
          this.$message.success('已安全退出登录') // 这里的 this 正确指向组件
          localStorage.removeItem('token')
          localStorage.removeItem('username')
          // 注意：如果 router 是通过 import 引入的，使用 router.push
          // 如果想使用 Vue 实例的 $router，请使用 this.$router.push
          router.push('/')
        } else {
          this.$message.warning('登出请求异常，但已清除本地状态。')
          localStorage.removeItem('token')
          localStorage.removeItem('username')
          router.push('/')
        }
      }).catch((error) => {
        // 网络错误或请求失败时执行
        console.error('登出请求失败:', error)
        this.$message.error('网络或服务器连接失败，已清除本地状态。')
        // 强烈建议在网络失败时也清除本地状态
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        router.push('/')
      })
    },
    goto (val) {
      router.push(val)
    },
    configpass () {
      router.push('/user/configpass')
    },
    isPast (time) {
      console.log('1:', new Date(time).getTime())
      console.log('2:', Date.now())
      return new Date(time).getTime() < Date.now()
    }
  }
}
</script>

<style scoped>
  .main-layout-container {
    height: 100vh;
  }

  /* 头部样式 */
  .main-header {
    background-color: #304156;
    color: #fff;
    line-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eee;
  }
  .main-header .logo {
    font-size: 20px;
    font-weight: bold;
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #fff;
  }

  /* 侧边栏样式 */
  .main-aside {
    /*#545c64*/
    background-color: #545c64;
    overflow-x: hidden; /* 防止菜单项文字过长导致滚动条 */
  }
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
    min-height: 400px;
  }
  .el-menu-vertical-demo {
    border-right: none; /* 移除菜单右侧边框 */
  }

  /* 主要内容区域 */
  .main-content {
    background-color: #f0f2f5;
    padding: 20px;
    overflow-y: auto; /* 允许内容区滚动 */
  }
</style>



// WEBPACK FOOTER //
// src/components/views/MainLayout.vue